import { Box, Container, Typography } from "@mui/material";
import heroImg from "../../assets/about/heroBanner.png";

const AboutHeroBanner = () => {
  return (
    <Box sx={styles.hero}>
      <Box sx={styles.overlayPattern} />
      {/* <Box sx={styles.accentLine} /> */}

      <Container maxWidth="lg" sx={styles.container}>
        <Typography variant="h2" sx={styles.heading}>
          About Zencon
        </Typography>

        <Typography sx={styles.subtitle}>
          Empowering businesses with reliable SAP expertise, digital solutions,
          and process-driven innovation.
        </Typography>
      </Container>

      <Box sx={styles.softGlow} />
      <Box sx={styles.bottomFade} />
    </Box>
  );
};

const styles = {
  hero: {
    position: "relative",
    maxHeight: { xs: 300, md: 300 },
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    backgroundImage: `
      linear-gradient(
        90deg,
        rgba(7, 21, 37, 0.94) 0%,
        rgba(7, 21, 37, 0.78) 45%,
        rgba(7, 21, 37, 0.35) 100%
      ),
      url(${heroImg})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },

  container: {
    position: "relative",
    zIndex: 3,
    minHeight: { xs: 300, md: 360 },
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: { xs: "center", md: "flex-start" },
    textAlign: { xs: "center", md: "left" },
  },

  heading: {
    color: "#fff",
    fontWeight: 800,
    lineHeight: 1.15,
    fontSize: { xs: "2.4rem", sm: "3rem", md: "4rem" },
    letterSpacing: "-1px",
  },

  subtitle: {
    mt: 2,
    maxWidth: 620,
    color: "rgba(255,255,255,0.78)",
    fontSize: { xs: "1rem", md: "1.25rem" },
    lineHeight: 1.7,
  },

  overlayPattern: {
    position: "absolute",
    inset: 0,
    zIndex: 1,
    opacity: 0.18,
    backgroundImage: `
      linear-gradient(rgba(255,255,255,0.08) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255,255,255,0.08) 1px, transparent 1px)
    `,
    backgroundSize: "48px 48px",
    maskImage:
      "linear-gradient(90deg, rgba(0,0,0,1), rgba(0,0,0,0.35), transparent)",
    WebkitMaskImage:
      "linear-gradient(90deg, rgba(0,0,0,1), rgba(0,0,0,0.35), transparent)",
  },

  accentLine: {
    position: "absolute",
    zIndex: 2,
    left: { xs: "50%", md: "calc((100% - 1200px) / 2 + 24px)" },
    top: { xs: "64%", md: "67%" },
    transform: { xs: "translateX(-50%)", md: "none" },
    width: { xs: 90, md: 120 },
    height: 4,
    borderRadius: 10,
    background: "linear-gradient(90deg, #00c853, rgba(0,200,83,0.15))",
  },

  softGlow: {
    position: "absolute",
    zIndex: 1,
    width: { xs: 220, md: 420 },
    height: { xs: 220, md: 420 },
    right: { xs: "-120px", md: "-80px" },
    top: { xs: "-80px", md: "-140px" },
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(0,200,83,0.22), rgba(0,200,83,0.04) 45%, transparent 70%)",
  },

  bottomFade: {
    position: "absolute",
    zIndex: 2,
    left: 0,
    right: 0,
    bottom: 0,
    height: "35%",
    background: "linear-gradient(to top, rgba(7,21,37,0.9), transparent)",
  },
};

export default AboutHeroBanner;
